

import styled from "styled-components"
import InputNumberExtraPrices from "../../shared/input/nakliyeHesaplama/InputNumberExtraPrices";
import useWindowDimensions from "../../../hooks/useWindowSize";

const Container = styled.div`
    width: ${({width}) => width};
    color: ${({theme}) => theme.mainTextColor};


`
const HighwayPriceList = ({data}) => {

    const {windowDimensions} = useWindowDimensions()
    

  return (
    <Container width={windowDimensions.width <= 1400 ? "100%" : "320px"}>
        <InputNumberExtraPrices keyData={"otobanPrice"} labelText={"Otoban Ücreti"} ek=" TL" isRequired={false} name={"otobanPrice"} inputWidth={"100%"}/>
    </Container>
  )
}

export default HighwayPriceList